// Necesario
import React from 'react';
// Theme y css
import { ThemeProviderCustom } from './Theme/ThemeContext';
import CssBaseline from "@mui/material/CssBaseline";
// Router
import { AuthProvider } from "./Auth/AuthContext";
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';

// Importar rutas
import { routes } from './Routes';

const App = () => {
  return (
    <AuthProvider>
      <ThemeProviderCustom>

        <CssBaseline />

        <Router>
            <Routes>
              {routes.map(({ path, element }, index) => (
                <Route key={index} path={path} element={element} />
              ))}
            </Routes>
        </Router>

      </ThemeProviderCustom>
    </AuthProvider>
  );
};

export default App;